import { ReactNode } from "react";
import { createPortal } from "react-dom";

type PopupProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  className?: string;
  children: ReactNode | ((props: { onClose: () => void }) => ReactNode);
};

export function Popup({ isOpen, onClose, title, className, children }: PopupProps) {
  if (!isOpen) return null;

  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-auto">
       <div className={`bg-white p-6 rounded-lg shadow-lg relative ${className}`}>
        {title && <h2 className="text-xl font-bold mb-4">{title}</h2>}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-xl"
        >
          ×
        </button>
        {typeof children === "function" ? children({ onClose }) : children}
      </div>
    </div>,
    document.body
  );
}
